import React, {FC} from 'react'
import {Box} from '@mui/material'

interface Props {
    children: React.ReactElement;
}

const ErrorMessageAreaWrapper: FC<Props> = ({children}) => {
    return (
        <Box data-error-area-scale="true">
            {children}
        </Box>
    )
}

ErrorMessageAreaWrapper.displayName = 'ErrorMessageAreaWrapper'
export default ErrorMessageAreaWrapper